import { useState, useEffect } from 'react';
import { useGetBrownlowPredictorQuery } from 'common/store/modules/api/afl-api';

/**
 * Custom hook to manage pagination and fetching more data.
 *
 * @param {Array} data - The complete dataset to paginate through.
 * @param {number} pageSize - The number of items per page.
 * @param season
 * @param page
 * @param team
 * @returns {[Array, Function, number, Function, Function]} - The current page data, function to fetch more data, current page number, and setter functions for shownData and currentPage.
 */
export const useBrownlowPlayers = (season, page, team) => {
    const [playerData, setPlayerData] = useState({
        season: null,
        page: null,
        team: null,
        list: []
    });
    const {
        data = {},
        isLoading,
        isFetching,
        isError
    } = useGetBrownlowPredictorQuery(
        {
            compSeasonId: season,
            page: page,
            team: team
        },
        {
            skip: !season
        },
        { refetchOnMountOrArgChange: true }
    );
    const { results: playerList = [], pageInfo = {}, compSeason } = data;

    useEffect(() => {
        setPlayerData({
            season,
            page: null,
            team,
            list: []
        });
    }, [season, team]);

    useEffect(() => {
        if (!compSeason?.id) {
            return;
        }
        setPlayerData((prev) => ({
            season: compSeason?.id,
            page: pageInfo.page,
            team,
            list: pageInfo.page > 0 ? [...prev.list, ...playerList] : playerList
        }));
    }, [playerList, pageInfo.page, compSeason?.id, team]);

    const hideLoadMoreBtn = pageInfo.page + 1 === pageInfo.numPages;

    return [playerData.list, isLoading, isFetching, isError, hideLoadMoreBtn];
};
